export default __webpack_public_path__ + "static/farger2-6363359e29bb3b2403a9bc61a99e9722.png";